import qs from 'qs';
// import { message } from 'antd';
import { cloneDeep, findIndex, isNumber } from 'lodash';
import moment from 'moment';
import location from './aLocation';

// 从当前url上获取当前的开发环境, dev,qa,线上
export const getEnv = () => {
    const dev = window.location.hostname.split('.')[1];
    const domain = window.location.hostname.substring(window.location.hostname.indexOf('.'));
    switch (dev) {
        case 'dev':
            return { name: '_D_W_I_S_ID_', domain };
        case 'qa':
            return { name: '_Q_W_I_S_ID_', domain };
        case 'hsmob':
            return { name: '_W_I_S_ID_', domain };
        default:
            return null;
    }
};

// 处理时长,后台返回的是秒数
export const getDelayTime = time => {
    const d = 24 * 60 * 60,
        h = 60 * 60,
        m = 60;
    const day = Math.floor(time / d),
        hour = Math.floor((time - day * d) / h),
        minute = Math.floor((time - day * d - hour * h) / m);
    return day || hour || minute
        ? `${day ? day + '天 ' : ''}${hour ? hour + '小时 ' : ''}${minute ? minute + '分钟' : ''}`
        : 0;
};

export const redirectTo = (path, query = {}) => {
    path = `${safePath(path)}`;
    query = qs.stringify(query);
    if (query) {
        path += `?${query}`;
    }
    window.location.href = path;
};

export const redirectToLogin = () => {
    const pathname = location.pathname || '';
    const search = location.search || '';
    const matchers = pathname + search;
    const redirect = encodeURIComponent(matchers ? matchers : '/');
    redirectTo('/login', { redirect });
};

export const safePath = path => `/${path}`.replace(/\/+/g, '/');

export const redirectToURL = url => {
    if (!url) {
        url = '/';
    }
    window.location.href = url;
};

// 金额格式转换
export const currency = (number, unit = '', digits = 2) => {
    if (isNumber(number)) {
        if (isNumber(unit)) {
            digits = unit;
            unit = '&yen;';
        }
        number = number.toFixed(digits).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        return unit ? `${unit}${number}` : number;
    }
};

export const replace = (array = [], predicate, item) => {
    const index = findIndex(array, predicate);
    array.splice(index, 1, item);
    return array;
};

export function getUrlParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let hash = window.location.hash;
    const index = hash.indexOf('?') + 1;
    hash = window.location.hash.substr(index).match(reg);
    if (hash !== null) {
        return unescape(hash[2]);
    }
    return null;
}
/**
 * 列表数据如果有空值，就将其置为 -
 * @param {*} list   列表数组
 */
export function changeEmptyValue(list) {
    if (!list) {
        return [];
    }
    list = cloneDeep(list.slice());
    list.map(item => {
        Object.keys(item).map(key => {
            if (item[key] === '' || item[key] === null) {
                item[key] = '-';
            }
        });
    });
    return list;
}

/**
 * 维权状态：根据code获取显示的name
 * @param {int} refundStatus  维权状态码
 * @param {string} initialName  默认名称
 * @return {string} refundStatusName  维权状态名
 */
export function getRefundStatusName(refundStatus, initialName = '无维权') {
    const fixRefundStatus = [
        '申请维权',
        '已取消',
        '待买家退货',
        '已退货，待收货',
        '系统退款中',
        '退款成功',
        '退款失败',
        '待平台仲裁',
        '申请已驳回',
        '财务打款失败',
    ];
    let refundStatusName = initialName;
    if (refundStatus != null && refundStatus >= 0) {
        refundStatusName = fixRefundStatus[refundStatus];
    }
    return refundStatusName;
}

const { newLocation, translateAddress, aLocation } = location;
const areaOptions = newLocation;
/**
 * RangePicker选择的时间跨度限制 不能超过xx个月/天
 * @param {dataTime} type 选择的时间
 * @param {type} type month/day    限制的类型 按月/天
 * @param {range} type    限制的范围
 */
const disableRangeTime = (dataTime, type, range) => {
    const diff = dataTime[1] && dataTime[1].diff(dataTime[0], type, true);
    if (diff > range) {
        // message.warn(`时间跨度不能超过 ${range} 个月`);
        return false;
    }
    return true;
};

/**
 * 时间组件 禁用时间校验函数（禁止选择 大于今天 的日期）
 * 比如：今天为 2019-01-09 则不能选择 2019-01-10 和 10 号以后的日期
 * @param {*} current
 */
const disabledDateEndOfDay = current => {
    return current && current > moment().endOf('day');
};
export { areaOptions, aLocation, translateAddress, disableRangeTime, disabledDateEndOfDay };
